<template>
  <v-layout row wrap justify-center>
    <exchange-form
      ref="exc"
      @reset="reset"
      @saved="saved"
      v-model="exchange"
      key="exchange_form_dialog_1"
      class="flex xs12 shadow mb-4"
      v-if="initList && !reportView"
    />

    <bill-preview v-model="dialog">
      <exchange-bill slot="form" :exchange="showItem" key="bill_dialog" />
    </bill-preview>

    <form-dialog v-model="editDialog" :title="$t('edit_bill')" width="1000px">
      <exchange-form
        :edit="true"
        @reset="reset"
        @saved="saved"
        v-if="editDialog"
        v-model="itemForEdit"
        class="flex xs12 shadow"
        key="exchange_form_dialog"
      />
    </form-dialog>

    <v-card class="shadow flex xs12 pa-0">
      <div
        class="py-1 px-3 secondary white--text font-weight-bold di-flex justify-center align-center"
        v-if="!accountView"
      >
        <v-checkbox
          dark
          singleLine
          hideDetails
          color="primary"
          v-model="is_dab"
          title="Auction Results"
          style="max-width: 32px"
        />
        <span class="py-1">{{ $t("exchanges") }}</span>
        <v-spacer />
        <div v-if="!dashboardView && !accountView">
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn color="white" class="py-0 ma-0" flat dark v-on="on">
                <!-- <v-icon class="mx-2">more_vert</v-icon> -->
                <strong class="mt-1">{{ selected_currency.name }}</strong>
              </v-btn>
            </template>

            <v-list>
              <v-list-tile
                :key="index"
                @click="currencyChanged(item)"
                v-for="(item, index) in currencies"
              >
                <v-list-tile-title>{{ item.name }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </div>
        <!-- <div v-if="!dashboardView && !accountView">
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn color="white" class="py-0 ma-0" flat dark v-on="on">
                <strong class="mt-1"> {{ selected_type.text }} </strong>
              </v-btn>
            </template>

            <v-list>
              <v-list-tile
                :key="index"
                @click="typeChanged(item)"
                v-for="(item, index) in types"
              >
                <v-list-tile-title>{{ item.text }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </div>-->
      </div>
      <v-card-text class="pt-3">
        <v-layout row wrap class="flex-row align-center justify-center">
          <v-checkbox
            singleLine
            hideDetails
            color="primary"
            @change="initData"
            v-model="filter_date"
            style="max-width: 24px"
            v-if="!dashboardView && !accountView"
          />
          <v-date
            singleLine
            :hideDetails="true"
            @input="initData"
            format="YYYY-MM-DD"
            v-model="start_date"
            value-type="YYYY-MM-DD"
            input_id="start_date_excha"
            :placeholder="$t('start_date')"
            :disabled="!filter_date && !loading"
            v-if="!dashboardView && !accountView"
            class="mx-2 flex xs12 md2 hide-details"
          />
          <v-date
            singleLine
            :hideDetails="true"
            @input="initData"
            v-model="end_date"
            format="YYYY-MM-DD"
            value-type="YYYY-MM-DD"
            :placeholder="$t('end_date')"
            input_id="start_date_end_exchange"
            :disabled="!filter_date && !loading"
            v-if="!dashboardView && !accountView"
            class="mx-2 flex xs12 md2 hide-details"
          />
          <v-spacer />
          <v-text-field
            outline
            hide-details
            v-model="search"
            v-if="!dashboardView"
            style="max-width: 420px"
            class="flex xs12 rounded"
            :placeholder="$t('search')"
            prepend-inner-icon="search"
          />
          <v-btn
            flat
            icon
            class="mx-0"
            @click="initData"
            :loading="loading"
            color="grey darken-2"
            v-if="!dashboardView && !accountView"
          >
            <v-icon>refresh</v-icon>
          </v-btn>
          <v-btn icon flat class="mx-0" color="grey darken-2" @click="printTable(false)">
            <v-icon>print</v-icon>
          </v-btn>
          <v-btn flat icon class="mx-0" color="grey darken-2" @click="printTable(true)">
            <v-icon>file_download</v-icon>
          </v-btn>
        </v-layout>

        <v-data-table
          ref="tbl"
          :loading="loading"
          :headers="headers"
          disable-initial-sort
          :items="computedItems"
          :total-items="meta.total"
          :pagination.sync="pagination"
          :rows-per-page-items="per_page"
          :search="!initList ? search || externalSearch : ''"
        >
          <template slot="items" slot-scope="props">
            <tr
              @click="props.expanded = !props.expanded"
              @dblclick="
                $emit(
                  'customer_changed',
                  props.item.customer_id,
                  props.item.customer
                )
              "
            >
              <td
                :class="{
                  red: props.item.deleted_at,
                  'primary white--text font-weight-bold': props.item.is_dab,
                }"
              >{{ props.item.number }}</td>
              <td>{{ props.item.branch.name }}</td>
              <td>{{ props.item.details.corporate_name }}</td>
              <td>{{ props.item.details.name }}</td>
              <td
                :class="{
                  'red--text': props.item.exchanged_amount < 0,
                  'activeColor--text': props.item.exchanged_amount > 0,
                }"
              >{{ smbl(props.item.buy_currency_id) }}</td>
              <td
                :class="{
                  'red--text': props.item.amount < 0,
                  'activeColor--text': props.item.amount > 0,
                }"
              >{{ smbl(props.item.sale_currency_id) }}</td>
              <td>{{ props.item.rate }}</td>
              <td
                :class="{
                  'red--text': props.item.exchanged_amount < 0,
                  'activeColor--text': props.item.exchanged_amount > 0,
                }"
              >{{ props.item.exchanged_amount | currency }}</td>

              <td
                :class="{
                  'red--text': props.item.amount < 0,
                  'activeColor--text': props.item.amount > 0,
                }"
              >{{ props.item.amount | currency }}</td>
              <td
                :class="{
                  'red--text': props.item.base_profit < 0,
                  'activeColor--text': props.item.base_profit > 0,
                }"
              >{{ props.item.base_profit | currency({ symbol: smbl(1) }) }}</td>
              <td>
                <span class="wrap--text">{{ props.item.description }}</span>
              </td>
              <td>{{ props.item.date | persianDateFilter(true) }}</td>
              <td>{{ props.item.date | persianDateFilter }}</td>
              <td>{{ props.item.time }}</td>
              <td>{{ props.item.risk_category }}</td>
              <td v-if="trashed">{{ props.item.deleted_at }}</td>
              <td v-if="reportView">{{ props.item.user && props.item.user.name }}</td>
              <td>
                <v-btn
                  flat
                  icon
                  small
                  class="ma-0"
                  v-if="can.view"
                  color="grey darken-1"
                  :loading="props.item.loading"
                  @click="showExchange(props.item)"
                >
                  <v-icon>launch</v-icon>
                </v-btn>
                <v-btn
                  icon
                  flat
                  small
                  class="ma-0"
                  color="grey darken-1"
                  @click="editItem(props.item)"
                  v-if="can.edit && props.item.editable"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn
                  flat
                  icon
                  small
                  class="ma-0"
                  color="grey darken-1"
                  @click="deleteItem(props.item)"
                  v-if="can.delete && props.item.editable"
                >
                  <v-icon>delete_outline</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
          <template v-slot:expand="{ item }">
            <v-divider></v-divider>
            <file-viewer :files="item.details.files" />
          </template>
          <template slot="footer">
            <tr :key="key" class="font-weight-bold" v-for="(value, key) in summery.currencies">
              <td colspan="6">{{ $t("total") }} {{ smbl(value) }}</td>
              <td
                class="lr--text px-3"
                :title="$t('buy')"
              >{{ summery.exchanged_amount[value] | currency }}</td>
              <td :title="$t('sale')">{{ summery.amount[value] | currency }}</td>
              <td colspan="2" :title="$t('profit')">
                <span v-if="value == base_currency_id">
                  {{
                  summery.base_profit
                  | currency({ symbol: smbl(base_currency_id) })
                  }}
                </span>
              </td>
              <td
                :title="$t('exposed_amount')"
                colspan="2"
                :class="{
                  'red--text': summery.exposed_amount[value] < 0,
                  'activeColor--text': summery.exposed_amount[value] > 0,
                }"
              >
                <span>
                  {{
                  summery.exposed_amount[value]
                  | currency({ symbol: smbl(value) })
                  }}
                </span>
              </td>
              <td
                colspan="100%"
                :title="$t('avg_rate')"
              >{{ ratesByDate[value] && ratesByDate[value].rate }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-layout>
</template>

<script>
let currentTime = new Date();
import curjs from "currency.js";
import debounce from "@/plugins/vDebounce";
import { customersMixin } from "@/mixins/index.js";

export default {
  name: "exchangesTable",
  mixins: [customersMixin],
  props: {
    pep: { default: false },
    str: { default: false },
    lctr: { default: false },
    date: { default: null },
    st_date: { default: null },
    en_date: { default: null },
    trashed: { default: false },
    initList: { default: true },
    externals: { default: false },
    auction: { default: false },
    reportView: { default: false },
    externalSearch: { default: "" },
    suction_checked: { default: false },
    accountView: { default: false },
    exchanges: { default: () => [] },
    dashboardView: { default: false },
    brnch_name: { default: "" },
    branch_id: { default: undefined },
    customer_id: { default: null },
    risk_category: { default: undefined }
  },
  data: () => ({
    search: "",
    items: [],
    is_dab: false,
    dialog: false,
    editIndex: -1,
    loading: false,
    editDialog: false,
    selected_currency: {
      id: undefined,
      name: "ALl Currencies"
    },
    selected_type: {
      value: undefined,
      text: "All Types"
    },
    showItem: {
      items: []
    },

    exchange: {
      doctype: "passport",
      details: {},
      files: [],
      items: [
        {
          date: currentTime.toLocaleDateString("en-ca"),
          rate: 1,
          amount: null,
          buy_currency_id: null,
          buy_customer_id: null,
          // buy_to_base_rate: null,
          exchanged_amount: null,
          sale_currency_id: null,
          sale_customer_id: null
        }
      ]
    },
    itemForEdit: {
      files: [],
      doctype: "passport",
      details: {},
      items: [
        {
          date: currentTime.toLocaleDateString("en-ca"),
          rate: 1,
          amount: null,
          base_amount: null,
          buy_currency_id: null,
          buy_customer_id: null,
          buy_to_base_rate: null,
          sale_to_base_rate: null,
          exchanged_amount: null,
          sale_currency_id: null,
          sale_customer_id: null
        }
      ]
    },
    ratesByDate: {},
    meta: {
      total: 0,
      perPage: 0,
      current_page: 0
    },
    filter_date: true,
    pagination: { page: 1, rowsPerPage: 100 },
    end_date: currentTime.toLocaleDateString("en-ca"),
    start_date: currentTime.toLocaleDateString("en-ca")
  }),

  computed: {
    types() {
      return [
        {
          value: undefined,
          text: "All Types"
        },
        {
          text: "Sale",
          value: "sale"
        },
        {
          text: "Buy",
          value: "buy"
        },
        {
          text: "F2F",
          value: "f2f"
        }
      ];
    },

    currencies() {
      let items = this.initialData.currencies;
      return [{ id: undefined, name: "ALl Currencies" }, ...items];
    },

    summery() {
      let amount = {};
      let avg_rates = {};
      let base_profit = 0;
      let currencies = {};
      let exposed_amount = {};
      let exchanged_amount = {};

      this.computedItems.forEach(item => {
        base_profit += item.base_profit;
        //sum amounts by currency
        if (!amount[item.sale_currency_id]) amount[item.sale_currency_id] = 0;
        amount[item.sale_currency_id] =
          amount[item.sale_currency_id] + Number(item.amount);

        // sum exchenges by currency
        if (!exchanged_amount[item.buy_currency_id])
          exchanged_amount[item.buy_currency_id] = 0;
        exchanged_amount[item.buy_currency_id] =
          exchanged_amount[item.buy_currency_id] +
          Number(item.exchanged_amount);

        if (!exposed_amount[item.buy_currency_id])
          exposed_amount[item.buy_currency_id] = 0;
        exposed_amount[item.buy_currency_id] =
          exposed_amount[item.buy_currency_id] + Number(item.exchanged_amount);

        if (!exposed_amount[item.sale_currency_id])
          exposed_amount[item.sale_currency_id] = 0;
        exposed_amount[item.sale_currency_id] =
          exposed_amount[item.sale_currency_id] - Number(item.amount);

        // add amount or exchange currency to used list
        if (item.sale_currency_id)
          currencies[item.sale_currency_id] = item.sale_currency_id;
        if (item.buy_currency_id)
          currencies[item.buy_currency_id] = item.buy_currency_id;
      });
      return {
        amount,
        exchanged_amount,
        base_profit,
        exposed_amount,
        currencies
      };
    },

    computedItems() {
      let items = [];
      if (this.initList) items = this.items;
      else items = this.exchanges;
      if (this.is_dab || this.auction) return items.filter(x => x.is_dab);
      else return items;
    },

    can() {
      return {
        add: this.userCan("add_exchanges"),
        view: this.userCan("view_exchanges"),
        edit: this.userCan("edit_exchanges"),
        delete: this.userCan("delete_exchanges"),
        any:
          this.userCan("edit_exchanges") ||
          this.userCan("view_exchanges") ||
          this.userCan("delete_exchanges")
      };
    },
    headers: vm => {
      let items = [
        {
          value: "number",
          width: "30px",
          sortable: false,
          text: vm.$t("tr")
        },
        {
          text: vm.$t("branch"),
          value: "branch.name"
        },
        // {
        //   value: "id",
        //   align: "right",
        //   width: "100px",
        //   sortable: false,
        //   text: vm.$t("exchange_number")
        // },
        {
          text: vm.$t("corporate_name"),
          value: "details.corporate_name"
        },
        {
          value: "details.name",
          text: vm.$t("customer")
        },
        {
          sortable: false,
          value: "exchanged_amount",
          text: vm.$t("buy_currency"),
          computed: item => `${vm.smbl(item.buy_currency_id)}`
        },
        {
          sortable: false,
          value: "amount",
          text: vm.$t("sale_currency"),
          computed: item => `${vm.smbl(item.sale_currency_id)}`
        },
        {
          width: "30px",
          value: "rate",
          sortable: false,
          text: vm.$t("rate")
        },
        {
          sortable: false,
          value: "exchanged_amount",
          text: vm.$t("purchase_amount"),
          computed: item => curjs(item.exchanged_amount).format({ symbol: "" })
        },
        {
          sortable: false,
          value: "amount",
          text: vm.$t("sale_amount"),
          computed: item => curjs(item.amount).format({ symbol: "" })
        },
        {
          sortable: false,
          value: "base_profit",
          text: vm.$t("profit"),
          computed: item =>
            curjs(item.base_profit).format({ symbol: "" }) + " USD"
        },
        {
          width: "400px",
          sortable: false,
          value: "description",
          text: vm.$t("description")
        },
        {
          value: "date",
          width: "120px",
          sortable: false,
          text: vm.$t("persian_date"),
          computed: item => vm.persianDateFilter(item.date, true)
        },
        {
          value: "date",
          width: "120px",
          sortable: false,
          text: vm.$t("date"),
          computed: item => vm.persianDateFilter(item.date)
        },
        {
          value: "time",
          width: "120px",
          sortable: false,
          text: vm.$t("time")
        },
        {
          width: "120px",
          sortable: false,
          value: "risk_category",
          text: vm.$t("risk_profile")
        }
      ];
      if (vm.trashed) {
        items.push({
          sortable: false,
          hidePrint: true,
          value: "deleted_at",
          text: vm.$t("deleted_at")
        });
      }
      if (vm.reportView) {
        items.push({
          sortable: false,
          hidePrint: true,
          value: "user.name",
          text: vm.$t("user")
        });
      }
      items.push({
        sortable: false,
        value: "actions",
        hidePrint: true,
        text: vm.$t("actions")
      });
      return items;
    },
    lctrheaders: vm => {
      return [
        {
          width: "30px",
          value: "number",
          sortable: true,
          text: vm.$t("tr")
        },
        {
          text: vm.$t("branch"),
          value: "branch.name"
        },
        {
          text: vm.$t("corporate_name"),
          value: "details.corporate_name"
        },
        {
          value: "details.name",
          text: vm.$t("customer")
        },
        {
          value: "details.father_name",
          text: vm.$t("father_name")
        },
        {
          value: "details.source_of_fund",
          text: vm.$t("source_of_fund")
        },
        {
          value: "details.purpose_of_transaction",
          text: vm.$t("purpose_of_transaction")
        },
        {
          value: "exchanged_amount",
          text: vm.$t("buy_currency"),
          computed: item => `${vm.smbl(item.buy_currency_id)}`
        },
        {
          value: "amount",
          text: vm.$t("sale_currency"),
          computed: item => `${vm.smbl(item.sale_currency_id)}`
        },
        {
          width: "30px",
          value: "rate",
          text: vm.$t("rate")
        },
        {
          value: "exchanged_amount",
          text: vm.$t("purchase_amount"),
          computed: item => curjs(item.exchanged_amount).format({ symbol: "" })
        },
        {
          value: "amount",
          text: vm.$t("sale_amount"),
          computed: item => curjs(item.amount).format({ symbol: "" })
        },
        {
          value: "base_profit",
          text: vm.$t("profit"),
          computed: item =>
            curjs(item.base_profit).format({ symbol: "" }) + " USD"
        },
        {
          value: "details.docno",
          text: vm.$t("doc_no")
        },
        {
          value: "details.address",
          text: vm.$t("address")
        },
        {
          value: "details.pretty_phones",
          text: vm.$t("phones")
        },
        {
          value: "details.place_of_birth",
          text: vm.$t("place_of_birth")
        },
        {
          value: "details.date_of_birth",
          text: vm.$t("date_of_birth")
        },
        // {
        //   width: "400px",
        //   sortable: false,
        //   value: "description",
        //   text: vm.$t("description"),
        // },
        {
          value: "date",
          width: "120px",
          text: vm.$t("persian_date"),
          computed: item => vm.persianDateFilter(item.date, true)
        },
        {
          value: "date",
          width: "120px",
          text: vm.$t("date"),
          computed: item => vm.persianDateFilter(item.date)
        },
        {
          value: "time",
          width: "120px",
          text: vm.$t("time")
        }
      ];
    }
  },
  methods: {
    reset() {
      let ct = new Date();
      let system = this.initialData.customers.find(x => x.type == "system") || {
        id: 1001
      };
      this.editIndex = -1;
      this.editDialog = false;
      this.exchange = this.itemForEdit = {
        files: [],
        id: undefined,
        paymenttype: "",
        customer: {},
        type: "buy",
        description: "",
        credit_amount: 0,
        has_credit: false,
        customer_id: system.id,
        doctype: "passport",
        items: [
          {
            rate: 1,
            amount: null,
            is_dab: false,
            id: undefined,
            buy_currency_id: null,
            buy_customer_id: system.id,
            // buy_to_base_rate: null,
            exchanged_amount: null,
            sale_currency_id: null,
            sale_customer_id: system.id
            // sale_to_base_rate: null,
          }
        ],
        risk_category: "Low",
        suction_checked: true,
        date: ct.toLocaleDateString("en-ca"),
        time: ct.toLocaleTimeString([], { hour12: false })
      };
      delete this.exchange.id;
    },

    saved(payload) {
      this.editDialog = false;
      this.initData();
      this.$emit("saved", payload);
      // this.reset();
    },

    showExchange(item) {
      item.loading = true;
      this.axios
        .get(`exchanges/${item.exchange_detail_id}`)
        .then(res => {
          this.showItem = res.data;
          this.dialog = true;
        })
        .catch(err => {
          console.log(err);
          item.loading = false;
        })
        .finally(() => {
          item.loading = false;
        });
    },

    editItem(item) {
      this.axios
        .get(`exchanges/${item.exchange_detail_id}`)
        .then(res => {
          this.editIndex = this.computedItems.indexOf(item);
          this.itemForEdit = res.data;
          this.editDialog = true;
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
        });
    },

    initData() {
      let route = `reports?ratesByDate=true&date=${this.en_date ||
        this.end_date}&branch_id=${this.branch_id || this.user.branch_id}`;

      // fetch current rates
      this.axios.get(route).then(res => {
        this.ratesByDate = res.data;
      });
      if (!this.initList) return;
      this.loading = true;
      let {
        pep,
        str,
        search,
        trashed,
        end_date,
        externals,
        branch_id,
        start_date,
        reportView,
        filter_date,
        customer_id,
        risk_category,
        suction_checked
      } = this;
      const { page, rowsPerPage } = this.pagination;
      let params = {
        pep,
        str,
        page,
        search,
        trashed,
        end_date,
        branch_id,
        externals,
        start_date,
        reportView,
        filter_date,
        customer_id,
        risk_category,
        suction_checked,
        per_page: rowsPerPage,
        type: this.selected_type.value,
        currency_id: this.selected_currency.id
      };
      this.axios
        .get("exchanges", { params })
        .then(resp => {
          this.meta = resp.data.meta;
          this.items = resp.data.data;
          this.pagination.totalItems = resp.data.meta.total;
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    currencyChanged(item) {
      this.selected_currency = item;
      this.initData();
    },
    typeChanged(item) {
      this.selected_type = item;
      this.initData();
    },
    deleteItem(item) {
      let vm = this;
      this.$alert("exchanges/" + item.id).then(() => {
        if (vm.computedItems)
          vm.computedItems.splice(vm.computedItems.indexOf(item), 1);
        else this.initData();
        this.getCustomers();
        vm.$emit("saved");
      });
    },

    printTable(excel) {
      let items = [...this.$refs.tbl.filteredItems];
      for (let currency in this.summery.currencies) {
        items.push({
          details: {
            name: this.$t("total") + " " + this.smbl(currency)
          },
          sale_currency_id: -1,
          buy_currency_id: -1,
          amount:
            curjs(this.summery.amount[currency]).format({ symbol: "" }) || 0,
          exchanged_amount:
            curjs(this.summery.exchanged_amount[currency]).format({
              symbol: ""
            }) || 0,
          description: curjs(
            this.summery.exposed_amount[currency] || 0
          ).format({ symbol: "" }),
          base_profit:
            currency == this.base_currency_id
              ? curjs(this.summery.base_profit).format({ symbol: "" })
              : 0,
          time: curjs(
            this.ratesByDate[currency] && this.ratesByDate[currency].rate
          ).format({ symbol: "" })
          // profit: {
          //   eb:
          //     currency == this.base_currency_id
          //       ? this.summery.profit.toFixed(2)
          //       : "",
          // },
        });
      }
      let headers =
        this.lctr || this.reportView
          ? this.lctrheaders
          : this.headers.filter(x => !x.hidePrint);
      let data = {
        items,
        headers,
        landscape: true,
        brnch_name: `${this.$t("exchanges")}${
          this.auction ? " - " + this.$t("dab_auction") + " -" : ""
        }${this.pep ? " -" + this.$t("pep") + " -" : ""}${
          this.externals ? " -" + this.$t("externals") + " -" : ""
        }${
          this.suction_checked ? " -" + this.$t("suction_checked") + " -" : ""
        } ${this.brnch_name}`,
        title: `${this.$t("from")} ( ${
          this.initList ? this.start_date : this.st_date
        } ${this.persianDateFilter(
          this.initList ? this.start_date : this.st_date,
          true
        )} ) ${this.$t("to")} ( ${
          this.initList ? this.end_date : this.en_date
        } ${this.persianDateFilter(
          this.initList ? this.end_date : this.en_date,
          true
        )} )`
      };

      if (excel) return this.xl_tables(data, "exchanges", this.LONG_APP_NAME);
      this.$store.commit("ReportsModule/setTableData", data);
      this.$router.push("/print");
    }
  },

  created() {
    this.reset();
  },

  watch: {
    pagination: {
      handler() {
        this.initData();
      },
      deep: true
    },
    branch_id: {
      handler() {
        this.initData();
      },
      deep: true
    },
    trashed: {
      handler() {
        this.initData();
      },
      deep: true
    },
    risk_category: {
      handler() {
        this.initData();
      },
      deep: true,
    },
    externals: {
      handler() {
        this.initData();
      },
      deep: true
    },
    pep: {
      handler() {
        this.initData();
      },
      deep: true
    }, 
    str: {
      handler() {
        this.initData();
      },
      deep: true
    },
    customer_id: {
      handler() {
        this.initData();
      },
      deep: true
    },
    suction_checked: {
      handler() {
        this.initData();
      },
      deep: true
    },
    search: debounce(function(newVal) {
      this.initData(newVal);
    }, 1000)
  },

  beforeRouteLeave(to, from, next) {
    if (this.exchange.items[0].buy_currency_id) {
      const answer = window.confirm(this.$t("unsave_alert"));
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else next();
  }
};
</script>
